import React from 'react'
import './SubCategoryTabs.css'
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks'
import { Trans, useTranslation } from 'react-i18next';
import appSlice, { setActiveSubCategory, setNavigationCollapsed, type SubSubCatId } from '../../store/slices/appSlice';

const SubCategoryTabs: React.FC = () => {
	const dispatch = useAppDispatch();
	const activeSubCategory = useAppSelector(state => state.app.activeSubCategory);
	const navigationCollapsed = useAppSelector(state => state.app.navigationCollapsed);

	const calculators = useAppSelector(appSlice.selectors.getCalculators);
	const { t } = useTranslation();

	const handleSubCatChange = (tabId: string) => {
		if (tabId as SubSubCatId)
			dispatch(setActiveSubCategory(tabId as SubSubCatId));
	}

	const implementedCalculators = ["gas_pvt", "water_content", "hydrates", "ipr", "vlp", "gas_rate_critical", "system_plot", "pressure_drop", "material_balance"];

	return (
		<nav className={`tab-navigation${navigationCollapsed ? ' tab-navigation--collapsed' : ''}`}>
			<div className="tab-navigation__content">
				<div className="tab-navigation__dropdown">
					<select
						className="tab-navigation__select"
						value={activeSubCategory}
						onChange={(event) => handleSubCatChange(event.target.value)}
						aria-label="Select tool"
					>
						{calculators.map((calc) => {
							const key = Object.keys(calc)[0]
							const values = Object.values(calc)[0] as readonly string[]

							if (values.length > 0) {
								return (
									<optgroup key={key} label={t(`tabs.${key}`)}>
										{values.map(val => (
											<option key={val} value={val}>
												{t(`tabs.${val}`)}
											</option>
										))}
									</optgroup>
								)
							}

							return (
								<option key={key} value={key}>
									{t(`tabs.${key}`)}
								</option>
							)
						})}
					</select>
				</div>
				<div className="tab-navigation__tabs">
					{calculators.map((calc) => {
						const key = Object.keys(calc)[0]
						const values = Object.values(calc)[0] as readonly string[]

						return (
							<React.Fragment key={key}>
								<button
									type="button"
									className={`tab ${activeSubCategory === key || values.includes(activeSubCategory) ? 'tab--active' : ''} ${!implementedCalculators.includes(key) ? 'tab--disabled' : ''}`}
									onClick={() => { const firstImpl = values.find(v => implementedCalculators.includes(v)); if (firstImpl || implementedCalculators.includes(key)) handleSubCatChange(firstImpl ?? key); }}
								>
									<Trans
										i18nKey={t(`tabs.${key}`)}
										components={{ sub: <sub />, sup: <sup /> }}
									/>
								</button>
								{values.map(val => (
									<button
										type="button"
										key={val}
										className={`tab tab--sub ${activeSubCategory === val ? 'tab--active' : ''} ${!implementedCalculators.includes(val) ? 'tab--disabled' : ''}`}
										onClick={() => { if (implementedCalculators.includes(val)) handleSubCatChange(val); }}
									>
										<Trans
											i18nKey={t(`tabs.${val}`)}
											components={{ sub: <sub />, sup: <sup /> }}
										/>
									</button>
								))}
							</React.Fragment>
						)
					})}
				</div>
			</div>
			<button
				type="button"
				className="tab-navigation__toggle"
				onClick={() => dispatch(setNavigationCollapsed(!navigationCollapsed))}
				aria-label={navigationCollapsed ? 'Expand navigation' : 'Collapse navigation'}
			>
				<span className="tab-navigation__toggle-icon">
					{navigationCollapsed ? '›' : '‹'}
				</span>
			</button>
		</nav>
	)
}

export default SubCategoryTabs;